// Detects the platform from a service name and returns an example target link.
// Used as a native input placeholder: greyed out, uncopiable, disappears on type/paste.
const DEFAULT = "https://... ou @nom_utilisateur";

export function linkExample(serviceName = "") {
  const s = String(serviceName || "").toLowerCase();
  if (!s) return DEFAULT;
  const has = (...w) => w.every((x) => s.includes(x));

  if (s.includes("youtube")) {
    if (has("subscriber") || has("abonn")) return "https://www.youtube.com/@NomDeLaChaine";
    return "https://www.youtube.com/watch?v=dQw4w9WgXcQ"; // views, likes, comments, shares
  }
  if (s.includes("instagram")) {
    if (has("follower") || has("abonn")) return "https://www.instagram.com/nom_utilisateur";
    return "https://www.instagram.com/p/Cxxxxxxxxxx/"; // likes, views, comments on a post
  }
  if (s.includes("facebook")) {
    if (has("page")) return "https://www.facebook.com/NomDePage";
    if (has("follower") || has("abonn")) return "https://www.facebook.com/NomDePage";
    return "https://www.facebook.com/NomDePage/posts/1234567890";
  }
  if (s.includes("tiktok")) {
    if (has("follower") || has("abonn")) return "https://www.tiktok.com/@nom_utilisateur";
    return "https://www.tiktok.com/@nom_utilisateur/video/1234567890123456789";
  }
  if (s.includes("twitter") || /\bx\b/.test(s)) {
    if (has("follower") || has("abonn")) return "https://twitter.com/nom_utilisateur";
    return "https://twitter.com/nom_utilisateur/status/1234567890";
  }
  if (s.includes("telegram")) return "https://t.me/nom_du_canal";
  if (s.includes("spotify")) return "https://open.spotify.com/track/xxxxxxxxxxxxxxxxxxxxxx";
  if (s.includes("twitch")) return "https://www.twitch.tv/nom_utilisateur";
  if (s.includes("soundcloud")) return "https://soundcloud.com/nom_utilisateur";
  if (s.includes("linkedin")) return "https://www.linkedin.com/in/nom_utilisateur";
  if (s.includes("discord")) return "https://discord.gg/invitation";
  if (s.includes("snapchat")) return "https://www.snapchat.com/add/nom_utilisateur";
  if (s.includes("pinterest")) return "https://www.pinterest.com/nom_utilisateur";
  return DEFAULT;
}
